import script from "./evaluationReport.vue?vue&type=script&setup=true&lang=js"
export * from "./evaluationReport.vue?vue&type=script&setup=true&lang=js"

import "./evaluationReport.vue?vue&type=style&index=0&id=3f151126&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f151126"]])

export default __exports__